import styled from 'styled-components'

import { colors } from '@galo-monitor/styles'
import fonts from '@galo-monitor/styles/fonts'

export const PopupTitle = styled.span`
  font-weight: ${ fonts.fontWeight.bold };
`

export const SectionTitle = styled.h3`
  font-size: 0.8rem;
  font-weight: ${ fonts.fontWeight.regular };
  margin: 0;
  color: ${ colors.lightGrey4 }
`